import { render, staticRenderFns } from "./truck_add.vue?vue&type=template&id=3ecb75cb&scoped=true&"
import script from "./truck_add.vue?vue&type=script&lang=js&"
export * from "./truck_add.vue?vue&type=script&lang=js&"
import style0 from "./truck_add.vue?vue&type=style&index=0&id=3ecb75cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb75cb",
  null
  
)

export default component.exports